import { useState, useEffect } from "react";
import { Facebook, Twitter, Instagram, Mail } from "lucide-react";
import "./css/Footer.css";

export default function Footer() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    // Match the current theme with the navbar
    setDarkMode(document.documentElement.style.getPropertyValue("--bg-light") === "#1a202c");
  }, []);

  const handleMailClick = (event) => {
    const mailtoLink = "mailto:talk@snapcourse.in";

    // Create a temporary link and try to simulate a click
    const link = document.createElement("a");
    link.href = mailtoLink;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();

    // If email client doesn't open, redirect to a web-based email service (Gmail for example)
    setTimeout(() => {
      if (!document.hasFocus()) {
        window.location.href = "https://mail.google.com/mail/?view=cm&fs=1&to=talk@snapcourse.in"; // Fallback to Gmail
      }
    }, 200);
  };

  return (
    <footer className={`footer ${darkMode ? "dark" : "light"}`}>
      <div className="footer-content">
        <p>&copy; 2025 GaganDevRaj. All Rights Reserved.</p>
        <div className="social-icons">
          {/* <a href="#"><Facebook size={20} /></a> */}
          <a href="https://x.com/adarshji10100"><Twitter size={20} /></a>
          <a href="https://instagram.com/donotfollowmeokay" target="a_blank"><Instagram size={20} /></a>
          <a href="#" onClick={handleMailClick}>
            <Mail size={24} />
          </a> {/* Handle mail click with fallback */}
        </div>
      </div>
    </footer>
  );
}
